export default __webpack_public_path__ + "static/media/close-icon.5c4d1ea3.svg";